import styled from 'styled-components';

const Container = styled.div`
  width: 50rem;
  height: 69rem;
`;

const Slide = styled.div`
  width: 50rem;
  height: 69rem;
`;

export { Container, Slide };
